import { render, staticRenderFns } from "./TreeMenuWrapper.vue?vue&type=template&id=377b807e&lang=pug"
import script from "./TreeMenuWrapper.vue?vue&type=script&lang=js"
export * from "./TreeMenuWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports